/** @format */

import {
  loadCommodity,
  showDeleteConfirmationDialog,
  setSelectedCommodity,
  showAddEditDialog,
} from "./cocoaCommodityActions";

export const newCommodity = {
  name: "",
  grade: "",
  region: "",
  shortName: "",
  symbol: "",
  market: "",
};
export const initialCommodityState = {
  commodities: [],
  showDeleteConfirmDialog: false,
  showInsertEditDialog: false,
  selectedCommodity: {},
};

export const commoditiesReducer = (state = initialCommodityState, action) => {
  switch (action.type) {
    case loadCommodity.type:
      return {
        ...state,
        commodities: action.payload,
      };
    case showDeleteConfirmationDialog.type:
      return {
        ...state,
        showDeleteConfirmDialog: action.payload,
      };
    case showAddEditDialog.type:
      return {
        ...state,
        showInsertEditDialog: action.payload,
      };
    case setSelectedCommodity.type:
      return {
        ...state,
        selectedCommodity: action.payload,
      };
    default:
      return state;
  }
};
